import React, { Component } from "react";
import { Container, Button, Row, Col, Image, Form } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import IconCongrats from "../../assets/congrats_icon.png";
import IconTime from "../../assets/icon-time.svg";
import {
  formatNumberOnDashBoard,
  GROUP_KEYS,
  isValidArray,
  transformProjectCategoryId,
  dateFormat,
  formatNumber,
  getLocalstorage,
  setLocalstorage,
  getColor,
  Project_Stage_Helper,
  projectFormLabel
} from "../../helper";
import { get, isString } from "lodash";
import { getProjectDetails } from "../../actions/projectDetail.action";
import { LoaderPage } from "../../component/Loader";
import { PATHS, STATUS } from "../../constant";
import { getIssueList, getProjectList } from "../../actions/common.action";
import { clearProjectDataAction } from "../../actions/formData.action";
import DisplayByPermission from "../../component/DisplayByPermission";
import { setDraftDataForMilestone } from "./helper";
import PreviewMilestone from "./Milestones/PreviewMilestone";
import { ProjectDetailsExtension } from "../projectDetails/ProjectDetailsExtension";

export class Success extends Component {
  constructor() {
    super();
    this.state = {
      issueListDTO: {}
    };
  }

  componentDidMount() {
    const {
      getProjectDetails,
      getProjectList,
      history,
      history: {
        location: {
          state: { projectId }
        }
      }
    } = this.props;
    if (Number.isInteger(projectId)) {
      getProjectDetails(undefined, { id: projectId });
      const userInfo = getLocalstorage("user");
      userInfo.projectCreatedBy = true;
      setLocalstorage("user", userInfo);
      this.getIssueListData(projectId);
      //this.getProjectListData();
    } else {
      history.push(PATHS.DASHBOARD);
    }
  }

  getIssueListData = id => {
    try {
      this.setState(
        {
          issueListApiStatus: STATUS.LOADING
        },
        async () => {
          const response = await getIssueList(undefined, {
            offset: 0,
            limit: 10,
            projectId: id
          });
          if (response) {
            const { status, message, data } = response;
            if (status) {
              this.setState({
                issueListDTO: data,
                issueListApiStatus: STATUS.SUCCESS
              });
            } else {
              this.setState({
                issueListDTO: data,
                issueListApiStatus: STATUS.ERROR
              });
            }
          }
        }
      );
    } catch (e) {
      console.log("Error while fetching error", e);
    }
  };

  // getProjectListData = (param = {}) => {
  //   const { projectListParams } = this.state;
  //   this.setState(
  //     {
  //       projectListApiStatus: STATUS.LOADING,
  //       projectListParams: currentParams
  //     },
  //     async () => {
  //       const response = await getProjectList(undefined, currentParams);
  //       if (response) {
  //         const { data, status } = response;
  //         if (status) {
  //           this.setState({
  //             projectListDTO: data,
  //             projectListApiStatus: STATUS.SUCCESS
  //           });
  //         } else {
  //           this.setState({
  //             projectListDTO: data,
  //             projectListApiStatus: STATUS.ERROR
  //           });
  //         }
  //       }
  //     }
  //   );
  // };

  handlePrint = () => {
    window.print();
  };
  getDropDownName(array, targetId) {
    const foundObject = array.find(item => item.id == targetId);
    const foundObject1 = array.find(item => item.id === targetId);
    console.log(foundObject);
    console.log(foundObject1);
    if (foundObject) {
      return foundObject.name;
    } else {
      return "NA";
    }
  }
  render() {
    const {
      loading,
      projectData,
      issueListData,
      history: {
        location: {
          state: { projectId, message, projectNameTitle = "Project Name" }
        }
      }
    } = this.props;
    const pliData = projectData["data"];
    const { issueListDTO } = this.state;
    let issueList = get(issueListData, "data.listDTO", []);
    let data = get(projectData, "data") || {};
    const userInfo = getLocalstorage("user");
    const isUserStatePMG = userInfo.groupCategory === "STATE_PMG";
    let status =
      isString(get(data, "status")) &&
      get(data, "status")
        .replace(/[_]/, " ")
        .toLowerCase();

    let bankCount = get(data, "banks", []).length;
    let bucketDataDTOList = get(data, "bucketDataDTOList", []);
    let bucketMilestoneCOS = setDraftDataForMilestone(bucketDataDTOList);

    const createdBy =
      data && data.projectPPList && data.projectPPList.length
        ? data.projectPPList[0]
          ? data.projectPPList[0].name
          : null
        : null;

    return (
      <React.Fragment className="thankyou-wrapper container">
        <LoaderPage loading={loading === "LOADING"} />
        <div className="thankyou-inner-wrapper">
          <div className="congrats-banner">
            <Image src={IconCongrats} alt="Congratulations" />
            <div className="congrats-banner-text">
              <h1
                className="page-heading"
                data-test="project-success-confirmation-message"
              >
                {message || "NA"}
              </h1>
              <div className="congrats-desc">
                <p>
                  Your Project and/or Issue(s) has been successfully submitted
                  to the <b>{get(data, "sponsoredBy", "NA")}</b> for
                  Verification.
                </p>
                <div className="congrats-buttons">
                  {/* <Button className="btn-orange-invert btn-small">
                    <div className="download-icon orange" />
                    Download
                  </Button> */}
                  <Button
                    className="btn-orange-invert btn-small"
                    onClick={this.handlePrint}
                  >
                    <div className="print-icon orange" />
                    Print
                  </Button>
                </div>
              </div>
              <div className="project-id">
                Project ID{" "}
                <b data-test="created-project-id">: {projectId || "NA"}</b>
              </div>
              <Link to={PATHS.DASHBOARD}>
                <Button
                  variant="primary"
                  className="btn-orange no-padding"
                  data-test="move-to-dashboard-button"
                >
                  Move to Dashboard
                </Button>
              </Link>
            </div>
          </div>
          <Container
            className="thankyou-project-info"
            data-test="successfully-created-project-info"
            fluid
          >
            <div className="project-desc">
              <div className="project-heading">
                <h2>Project Information</h2>
                <ul>
                  <li>
                    Project ID <span className="custom-colon">:</span>{" "}
                    <b>{projectId || "NA"}</b>
                  </li>
                  <li>
                    Submission Date <span className="custom-colon">:</span>{" "}
                    <b>{dateFormat(get(data, "createdDate", "NA"))}</b>
                  </li>
                </ul>
              </div>
              <div className="project-status">
                <div className="assigned-to">
                  <p>
                    Assigned to <b>{get(data, "sponsoredBy", "NA")}</b>
                  </p>
                  <span>
                    <Image src={IconTime} alt="Time" />
                    from today
                  </span>
                </div>
                <Button
                  className={`btn-small  unClickable ${getColor(status)}`}
                >
                  {status}
                </Button>
              </div>
            </div>
            <div className="project-info">
              <Row>
                <Col lg={5}>
                  {projectFormLabel(
                    get(data, "sponsoredByid"),
                    "name",
                    projectNameTitle
                  )}
                </Col>
                <Col lg={7} data-test="project-name-in-project-details">
                  <span
                    className={`${
                      /[\u0900-\u097F]/.test(get(data, "name"))
                        ? "hindi-text-wrap line-height-preview"
                        : ""
                    }`}
                  >
                    {get(data, "name", "NA")}
                  </span>
                </Col>
              </Row>
              <Row>
                <Col lg={5}>
                  {projectFormLabel(
                    get(data, "sponsoredByid"),
                    "description",
                    "Brief Project Description"
                  )}
                </Col>
                <Col lg={7} data-test="project-description">
                  <span
                    className={`${
                      /[\u0900-\u097F]/.test(get(data, "description"))
                        ? "hindi-text-wrap line-height-preview"
                        : ""
                    }`}
                  >
                    {get(data, "description", "NA")}
                  </span>
                </Col>
              </Row>
              <Row>
                <Col lg={5}>CIN Number </Col>
                <Col lg={7}>{get(data, "cin") || "NA"}</Col>
              </Row>
              <Row>
                <Col lg={5}>Sponsored By</Col>
                <Col lg={7}>{get(data, "sponsoredBy") || "NA"}</Col>
              </Row>
              {get(data, "sponsoringDepartment") ? (
                <Row>
                  <Col lg={5}>
                    {projectFormLabel(
                      get(data, "sponsoredByid"),
                      "department",
                      `${
                        get(data, "sponsoredBy", "NA") == "Arunachal Pradesh"
                          ? "Beneficiary Department"
                          : "Sponsoring Department"
                      }`
                    )}
                  </Col>
                  <Col lg={7}>
                    {get(data, "sponsoringDepartment.name") || "NA"}
                  </Col>
                </Row>
              ) : null}
              {isValidArray(get(data, "districtName")) ? (
                <Row>
                  <Col lg={5}>District/Department</Col>
                  <Col lg={7}>
                    {get(data, "districtName")
                      .map(
                        value =>
                          `${value.name} ${
                            value.parentName ? `(${value.parentName})` : ""
                          }`
                      )
                      .join(", ")}
                  </Col>
                </Row>
              ) : null}
              <Row>
                <Col lg={5}>Proponent</Col>
                <Col lg={7}>{createdBy || "NA"}</Col>
              </Row>
              <Row>
                <Col lg={5}>Project Cost (in Crores)</Col>
                <Col lg={7}>
                  &#8377;{" "}
                  {formatNumber(
                    get(data, "revisedCost", 0) || get(data, "cost", 0)
                  )}{" "}
                  Cr.
                </Col>
              </Row>
              {get(data, "revisedCost", null) && (
                <Row>
                  <Col lg={5}>Project Cost (in crores)</Col>
                  <Col lg={7}>
                    &#8377; {formatNumber(get(data, "revisedCost", 0))} Cr.
                  </Col>
                </Row>
              )}
              {data.fundReleaseCost == null ? null : (
                <Row>
                  <Col lg={5}>
                    Funds released to the Executing Agency (in crores)
                  </Col>
                  <Col lg={7}>
                    &#8377; {formatNumber(get(data, "fundReleaseCost", 0))} Cr.
                  </Col>
                </Row>
              )}
              {/* {get(data, "fundReleaseCost", null) ||
                (get(data, "fundReleaseCost") == 0 && (
                  <Row>
                    <Col lg={5}>
                      Funds released to the Executing Agency (in crores)
                    </Col>
                    <Col lg={7}>
                      &#8377; {formatNumber(get(data, "fundReleaseCost", 0))}{" "}
                      Cr.
                    </Col>
                  </Row>
                ))} */}
              <ProjectDetailsExtension
                data={data}
                sponsoredByid={get(data, "sponsoredByid")}
                fieldName={"project_cost_share"}
              />

              <Row>
                <Col lg={5}>Location</Col>
                <Col lg={7} className="add-scroll">
                  {(isValidArray(get(data, "locations")) &&
                    get(data, "locations").map((list, index) => (
                      <p key={`success-${index}`}>
                        State: {list.state}{" "}
                        {(list.districtIdName &&
                          list.districtIdName.length &&
                          `| ${
                            list.districtIdName.length === 1
                              ? `District`
                              : "Districts"
                          }:
                                  ${list.districtIdName.map(
                                    item => item.name
                                  )}`) ||
                          null}{" "}
                        {(list.circleIdName &&
                          list.circleIdName.length &&
                          `| ${
                            list.circleIdName.length === 1
                              ? `Circle`
                              : "Circles"
                          }:
                                  ${list.circleIdName.map(
                                    item => item.name
                                  )}`) ||
                          null}
                        {/* {(list.distance &&
                          `| Distance(Km): ${formatNumber(list.distance)}`) ||
                          null}{" "}
                        {(list.cost &&
                          `| Cost(Cr):
                        ${formatNumberOnDashBoard(list.cost)}`) ||
                          null} */}
                      </p>
                    ))) ||
                    "NA"}
                </Col>
              </Row>
              <Row>
                <Col lg={5}>Implementation Mode</Col>
                <Col lg={7}>
                  {get(data, "implMode") == null
                    ? "NA"
                    : get(data, "implMode", "NA")}
                </Col>
              </Row>

              <ProjectDetailsExtension
                data={data}
                sponsoredByid={get(data, "sponsoredByid")}
                fieldName={"geo_coordinates"}
                sponsoredByCategory={get(data, "sponsoredByCategory")}
              />
              {get(data, "executingAgency", null) && (
                <Row>
                  <Col lg={5}>Executing Agency Name</Col>
                  <Col lg={7}>{get(data, "executingAgency", null) || null}</Col>
                </Row>
              )}
              {(get(data, "centralCost", null) && (
                <Row>
                  <Col lg={5}>Project Cost Share (in crores)</Col>
                  <Col lg={7}>
                    <span>Central Share</span> &#8377;{" "}
                    {formatNumber(
                      get(data, "centralCost", null) ||
                        get(data, "centralCost", 0)
                    )}{" "}
                    Cr. <span style={{ paddingLeft: "1em" }}>State Share</span>{" "}
                    &#8377;{" "}
                    {formatNumber(
                      get(data, "stateCost", null) || get(data, "stateCost", 0)
                    )}{" "}
                    Cr.
                  </Col>
                </Row>
              )) ||
                null}
              <Row
                style={{
                  display:
                    get(data, "sponsoredBy", "NA") == "Arunachal Pradesh"
                      ? "none"
                      : null
                }}
              >
                <Col lg={5}>Bank</Col>
                <Col lg={7}>
                  {(isValidArray(get(data, "banks")) &&
                    get(data, "banks").map((bankList, index) => {
                      let separator = index < bankCount - 1 ? "," : null;
                      if (bankList.id === 51) {
                        return (
                          <span key={index}>
                            {get(data, "otherBankName", null)}
                            {separator}&nbsp;
                          </span>
                        );
                      } else {
                        return (
                          <span>
                            {bankList}
                            {separator}&nbsp;
                          </span>
                        );
                      }
                    })) ||
                    "NA"}
                </Col>
              </Row>
              {get(data, "schemeForAr", null) && (
                <Row>
                  <Col lg={5}>Project Scheme</Col>
                  <Col lg={7}>{get(data, "schemeForAr", null) || null}</Col>
                </Row>
              )}
              {get(data, "sponsoringAgencyList", null) && (
                <Row>
                  <Col lg={5}>Sponsoring Agency</Col>
                  <Col lg={7}>
                    {this.getDropDownName(
                      data.sponsoringAgencyList,
                      data.sponsoringAgency
                    )}
                  </Col>
                </Row>
              )}
              <Row>
                <Col lg={5}>Date of Financial Closure Expected</Col>
                <Col lg={7}>
                  {(get(data, "finClosureExpDate") &&
                    dateFormat(get(data, "finClosureExpDate"))) ||
                    "NA"}
                </Col>
              </Row>
              <Row>
                <Col lg={5}>Date of Financial Closure Actual</Col>
                <Col lg={7}>
                  {(get(data, "finClosureDate") &&
                    dateFormat(get(data, "finClosureDate"))) ||
                    "NA"}
                </Col>
              </Row>
              <Row>
                <Col lg={5}>Project Stage</Col>
                <Col lg={7}>
                  {get(data, "implementationStarted", "NA")
                    .toLowerCase()
                    .replace(/_/g, " ")
                    .replace(/(?: |\b)(\w)/g, function(key, p1) {
                      return key.toUpperCase();
                    })}
                </Col>
              </Row>

              <ProjectDetailsExtension
                data={data}
                sponsoredByid={get(data, "sponsoredByid")}
                fieldName={"population_benefitted"}
              />
              {/* {(get(data, "targetCompletionDate", null) && (
                <Row>
                  <Col lg={5}>Target Date Of Completion</Col>
                  <Col lg={7}>
                    {dateFormat(get(data, "targetCompletionDate", null))}
                  </Col>
                </Row>
              )) ||
                null} */}
              {(get(data, "projectCompletionDTO") && (
                <Row>
                  <Col lg={5}>Project Status</Col>
                  <Col lg={7}>
                    <div>
                      {get(data, "projectCompletionDTO.status") !==
                      "NO IMPLEMENTATION"
                        ? Project_Stage_Helper(
                            get(data, "projectCompletionDTO.status", "NA")
                          )
                        : "No Implementation"}
                    </div>
                    <div>
                      {get(data, "projectCompletionDTO.date") ? (
                        <div>
                          Date -{" "}
                          {dateFormat(get(data, "projectCompletionDTO.date"))}
                        </div>
                      ) : null}
                      {get(
                        data,
                        "projectCompletionDTO.physicalProgressAsOf"
                      ) ? (
                        <div>
                          Physical Progress As of -{" "}
                          {dateFormat(
                            get(
                              data,
                              "projectCompletionDTO.physicalProgressAsOf"
                            )
                          )}
                        </div>
                      ) : null}
                      {get(data, "projectCompletionDTO.percentage") ? (
                        <div>
                          Physical Progress -{" "}
                          {get(data, "projectCompletionDTO.percentage")}%
                        </div>
                      ) : null}
                    </div>
                  </Col>
                </Row>
              )) ||
                null}
              <Row>
                <Col lg={5}>Implementation Start Date</Col>
                <Col lg={7}>
                  {(get(data, "implementationStartDate") &&
                    dateFormat(get(data, "implementationStartDate"))) ||
                    "NA"}
                </Col>
              </Row>
              <Row>
                <Col lg={5}>Original Date of Completion</Col>
                <Col lg={7}>
                  {(get(data, "anticipatedDateOfCompletion") &&
                    dateFormat(get(data, "anticipatedDateOfCompletion"))) ||
                    "NA"}
                </Col>
              </Row>
              {(data && data.revisedTargetCompletionDate && (
                <Row>
                  <Col lg={5}>Revised Target Date of Completion</Col>
                  <Col lg={7}>
                    {dateFormat(data.revisedTargetCompletionDate)}
                  </Col>
                </Row>
              )) ||
                null}
              {get(data, "pliDTO.pli") && get(data, "implMode") === "PRIVATE" && (
                <Row>
                  <Col lg={5}>PLI</Col>
                  <Col lg={7}>
                    {(get(data, "pliDTO.pli") === true && "Yes") || "No"}
                  </Col>
                </Row>
              )}
              <DisplayByPermission display={get(data, "pragatiDTO")}>
                <Row
                  style={{
                    display: get(data, "sponsoredBy") == "Bihar" ? "none" : null
                  }}
                >
                  <Col lg={5}>Pragati Review</Col>
                  <Col lg={7}>
                    {(get(data, "pragatiDTO.pragatiReview") === true &&
                      "Yes") ||
                      "No"}
                  </Col>
                </Row>
              </DisplayByPermission>
              <DisplayByPermission display={get(data, "pragatiDTO")}>
                <Row
                  style={{
                    display: get(data, "sponsoredBy") == "Bihar" ? "none" : null
                  }}
                >
                  <Col lg={5}>Pragati Review Dates</Col>
                  <Col lg={7}>
                    {(get(data, "pragatiDTO.pragatiReviewDates") &&
                      get(data, "pragatiDTO.pragatiReviewDates").length &&
                      get(data, "pragatiDTO.pragatiReviewDates").map(item => {
                        return <div>{dateFormat(item)}</div>;
                      })) ||
                      "NA"}
                  </Col>
                </Row>
              </DisplayByPermission>
              <DisplayByPermission display={get(data, "nipDTO")}>
                <Row>
                  <Col lg={5}>NIP</Col>
                  <Col lg={7}>
                    {(get(data, "nipDTO.nipReview") === true && "Yes") || "No"}
                  </Col>
                </Row>
              </DisplayByPermission>
              <DisplayByPermission display={get(data, "nipDTO")}>
                <Row>
                  <Col lg={5}>NIP Inclusion Date</Col>
                  <Col lg={7}>
                    {(get(data, "nipDTO.nipReviewDate") &&
                      dateFormat(get(data, "nipDTO.nipReviewDate"))) ||
                      "NA"}
                  </Col>
                </Row>
              </DisplayByPermission>
              <DisplayByPermission display={get(data, "pmFoundationStoneDTO")}>
                <Row>
                  <Col lg={5}>PM Foundation Stone</Col>
                  <Col lg={7}>
                    {(get(data, "pmFoundationStoneDTO.pmFoundationStone") ===
                      true &&
                      "Yes") ||
                      "No"}
                  </Col>
                </Row>
              </DisplayByPermission>
              <DisplayByPermission display={get(data, "pmFoundationStoneDTO")}>
                <Row>
                  <Col lg={5}>PM Foundation Stone Date</Col>
                  <Col lg={7}>
                    {(get(data, "pmFoundationStoneDTO.pmFoundationStone") &&
                      dateFormat(
                        get(data, "pmFoundationStoneDTO.pmFoundationStoneDate")
                      )) ||
                      "NA"}
                  </Col>
                </Row>
              </DisplayByPermission>
              <DisplayByPermission display={get(data, "cmPragatiYatraDTO")}>
                <Row>
                  <Col lg={5}>CM PRAGATI Yatra</Col>
                  <Col lg={7}>
                    {(get(data, "cmPragatiYatraDTO.cmPragatiYatra") === true &&
                      "Yes") ||
                      "No"}
                  </Col>
                </Row>
              </DisplayByPermission>
              <DisplayByPermission display={get(data, "cmPragatiYatraDTO")}>
                <Row>
                  <Col lg={5}>CM PRAGATI Yatra Date</Col>
                  <Col lg={7}>
                    {(get(data, "cmPragatiYatraDTO.cmPragatiYatra") &&
                      dateFormat(
                        get(data, "cmPragatiYatraDTO.cmPragatiYatraDate")
                      )) ||
                      "NA"}
                  </Col>
                </Row>
              </DisplayByPermission>
              <DisplayByPermission display={get(data, "cmFoundationStoneDTO")}>
                <Row>
                  <Col lg={5}>CM Foundation Stone</Col>
                  <Col lg={7}>
                    {(get(data, "cmFoundationStoneDTO.cmFoundationStone") ===
                      true &&
                      "Yes") ||
                      "No"}
                  </Col>
                </Row>
              </DisplayByPermission>
              <DisplayByPermission display={get(data, "cmFoundationStoneDTO")}>
                <Row>
                  <Col lg={5}>CM Foundation Stone Date</Col>
                  <Col lg={7}>
                    {(get(data, "cmFoundationStoneDTO.cmFoundationStone") &&
                      dateFormat(
                        get(data, "cmFoundationStoneDTO.cmFoundationStoneDate")
                      )) ||
                      "NA"}
                  </Col>
                </Row>
              </DisplayByPermission>
              <DisplayByPermission display={get(data, "pmGatiShaktiDTO")}>
                <Row>
                  <Col lg={5}>PM Gatishakti</Col>
                  <Col lg={7}>
                    {(get(data, "pmGatiShaktiDTO.pmGatiShakti") === true &&
                      "Yes") ||
                      "No"}
                  </Col>
                </Row>
              </DisplayByPermission>
              <DisplayByPermission display={get(data, "pmGatiShaktiDTO")}>
                <Row>
                  <Col lg={5}>PM Gatishakti Date</Col>
                  <Col lg={7}>
                    {(get(data, "pmGatiShaktiDTO.pmGatiShakti") &&
                      dateFormat(
                        get(data, "pmGatiShaktiDTO.pmGatiShaktiDate")
                      )) ||
                      "NA"}
                  </Col>
                </Row>
              </DisplayByPermission>
              <Row>
                <Col lg={5}>Supporting Document</Col>
                <Col lg={7}>
                  <div className="attachment-added success-file">
                    {(isValidArray(get(data, "documents")) &&
                      get(data, "documents").map(file => (
                        <div className="project-download-icons">
                          <div className="download-icons-pdf">
                            {file.name.split(".").pop()}
                          </div>
                          <a
                            href={file.s3Url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {file.title || file.name}
                          </a>
                        </div>
                      ))) ||
                      "NA"}
                  </div>
                </Col>
              </Row>
            </div>
            <PreviewMilestone
              bucketMilestoneCOS={bucketMilestoneCOS.filter(
                item => item.bucketName !== "Cabinet Milestone"
              )}
              cabinetMilestone={bucketMilestoneCOS.find(
                item => item.bucketName === "Cabinet Milestone"
              )}
              // bucketMilestoneCOS={bucketMilestoneCOS}
              className={"success-milestone"}
            />
            <div className="issues-info-container">
              {isValidArray(get(issueListDTO, "listDTO")) &&
              get(issueListDTO, "listDTO")[0] &&
              get(issueListDTO, "listDTO")[0].title ? (
                <h2>Issue(s) Information</h2>
              ) : null}
              {(isValidArray(get(issueListDTO, "listDTO")) &&
                get(issueListDTO, "listDTO").map((list, index) => (
                  <div className="issues-info">
                    <p className="issue-number">
                      ISSUE <b># {list.id}</b>
                    </p>
                    <h2 className="issue-category">{list.title}</h2>
                    <p className="issue-place">
                      Recipient{" "}
                      {transformProjectCategoryId(list.recipientGroupCategory)}{" "}
                      - <span>{list.recipientGroup}</span>
                    </p>
                    {list.districtName ? (
                      <p className="issue-place">
                        District/Department - <span>{list.districtName}</span>
                      </p>
                    ) : null}
                    {get(list, "forum", null) ? (
                      <p className="issue-place">
                        Forum - <span>{get(list, "forum.name", null)}</span>
                      </p>
                    ) : (
                      <React.Fragment />
                    )}
                    {get(list, "dateOfOrder", null) ? (
                      <p className="issue-place">
                        Date of Order -{" "}
                        <span>
                          {dateFormat(get(list, "dateOfOrder", null))}
                        </span>
                      </p>
                    ) : (
                      <React.Fragment />
                    )}
                    <b className="issue-title">{list.category}</b>
                    <p className="issue-info">{list.description}</p>
                    <p className="issue-place">
                      Proponent - {list.creatorName}
                    </p>
                    <div className="attachment-added">
                      {get(list, "files", []).map(file => (
                        <div className="project-download-icons">
                          <div className="download-icons-pdf">
                            {get(file, "name")
                              .split(".")
                              .pop()}
                          </div>
                          <a
                            href={file.s3Url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {get(file, "name", "NA")}
                          </a>
                        </div>
                      )) || null}
                    </div>
                  </div>
                ))) ||
                null}
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectData: state.projectDetailsReducer.projectData,
    loading: state.projectDetailsReducer.projectDetailsStatus,
    issueListData: state.commonReducer.issueList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getProjectDetails: getProjectDetails,
      getProjectList: getProjectList,
      clearProjectDataDispatch: clearProjectDataAction
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Success)
);
